/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CameraFill: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 3C9.44772 3 9 3.44772 9 4C9 4.55228 9.44772 5 10 5H14C14.5523 5 15 4.55228 15 4C15 3.44772 14.5523 3 14 3H10ZM2 17V8C2 6.89543 2.89543 6 4 6H20C21.1046 6 22 6.89543 22 8V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17ZM12 16.5C14.2091 16.5 16 14.7091 16 12.5C16 10.2909 14.2091 8.5 12 8.5C9.79086 8.5 8 10.2909 8 12.5C8 14.7091 9.79086 16.5 12 16.5ZM14.5 12.5C14.5 13.8807 13.3807 15 12 15C10.6193 15 9.5 13.8807 9.5 12.5C9.5 11.1193 10.6193 10 12 10C13.3807 10 14.5 11.1193 14.5 12.5Z'
      fill='currentColor'
    />
  </React.Fragment>
)
